import { ispmApi } from './api';

const integrationService = {
  // ── Health Check ────────────────────────────────────────────────
  async getHealthStatus() {
    try {
      // Updated to your health endpoint
      const response = await ispmApi.get('/api/v1/health');
      // console.log("health_check", response.data);
      return response.data; // {"service":"...","status":"healthy","version":"1.0.0"}
    } catch (error) {
      console.error('Error fetching health:', error);
      throw error;
    }
  },

  // ── Fetch All Integrations ──────────────────────────────────────
  async getIntegrations() {
    try {
      const [healthRes] = await Promise.allSettled([
        this.getHealthStatus(),
      ]);

      const healthData = healthRes?.status === 'fulfilled' ? healthRes?.value : null;

      // ── Updated Parse logic for your health response ─────────────
      // Based on: {"service":"ISPM Rule Engine","status":"healthy","version":"1.0.0"}
      const isHealthy = healthData?.status === 'healthy';
      
      // Note: If you have a specific flag for 'mock' mode, add it here. 
      // For now, we'll assume healthy = connected.
      const status = isHealthy ? 'connected' : 'not_connected';

      return [
        {
          id: 'microsoft-entra-id',
          name: 'Microsoft Entra ID',
          platform: 'microsoft_entra_id',
          description: 'Cloud-based identity and access management service',
          status: status,
          category: 'IAM',
        }
        
      ];
    } catch (error) {
      console.error('Error building integrations:', error);
      throw error;
    }
  },

  // ── Sync Initiation (/collect) ──────────────────────────────────
  async syncIntegration(id) {
    if (id === 'microsoft-entra-id') {
      const response = await ispmApi.post('/api/v1/collect',{
            provider: "entra_id",
            use_local_storage: false
          });
      // Return .data so IntegrationCard gets { task_id: "..." } directly
      return response.data; 
    }
    throw new Error('Sync not supported for: ' + id);
  },
  
  // ── Task Polling (/task/{id}) ───────────────────────────────────
  async getTaskStatus(taskId) {
    try {
      const response = await ispmApi.get(`/api/v1/celery/task/${taskId}`);
      // Return .data so IntegrationCard gets { status: "PENDING" | "SUCCESS" }
      return response.data; 
    } catch (error) {
      console.error('Error fetching task status:', error);
      throw error;
    }
  },

  // ── Connection Test ─────────────────────────────────────────────
  async testConnection(id) {
    if (id === 'microsoft-entra-id') {
      try {
        const data = await this.getHealthStatus();
        const isHealthy = data?.status === 'healthy';
        return {
          success: isHealthy,
          message: isHealthy ? 'Connection is healthy' : 'Connection degraded or unreachable',
        };
      } catch (err) {
        return { success: false, message: 'Could not reach health endpoint' };
      }
    }
    return { success: false, message: 'Platform not configured' };
  },
};

export default integrationService;